import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import en from './en.json';
import it from './it.json';
import de from './de.json';

export const languageResources = {
    en: {translation: en},
    it: {translation: it},
    de: {translation: de},
};

const localeCode = navigator.language;


i18next
.use(initReactI18next)
.init({
    compatibilityJSON: 'v3',
    lng: localeCode.substring(0,2),
    fallbackLng: 'en',
    resources: languageResources
});

export default i18next;